const SET_NAVIGATION_OPEN = 'SET_NAVIGATION_OPEN';

export {
  SET_NAVIGATION_OPEN
};

